import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const GarSubscriptionsRepository = RepositoryFactory.get("garSubscriptions");

const state = {
  subscriptions: [],
  subscription: {},
  establishments: [],
  establishment: {},
  lastCodeProject: "",
};

const getters = {
  getEstablishments: () => state.establishments,
  getSubscription: () => state.subscription,
};

const actions = {
  getSubscriptions({ commit, dispatch, state }, params = {}) {
    dispatch("loadings/enableLoadings", {}, { root: true });

    GarSubscriptionsRepository.getSubscriptions(params)
      .then((response) => {
        const subscriptions = response.data.results;
        commit("SAVE_SUBSCRIPTIONS", subscriptions);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.garSubscriptions.getSubscripionsError`,
            ),
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  getSubscription({ commit, dispatch, state }, id) {
    dispatch("loadings/enableLoadings", {}, { root: true });

    return GarSubscriptionsRepository.getSubscription(id)
      .then((response) => {
        const subscription = response.data;
        commit("SAVE_SUBSCRIPTION", subscription);
        if (
          !("codeProjetRessource" in subscription) &&
          state.lastCodeProject !== ""
        ) {
          dispatch(
            "notifications/addWarning",
            {
              message: state.$t("message.garSubscription.projectCodeError"),
            },
            { root: true },
          );
          commit("RESET_LAST_CODE_PROJECT");
        }
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.garSubscriptions.getSubscripionError`,
            ),
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  createSubscription({ dispatch, state }, params = {}) {
    dispatch("loadings/enableLoadings", {}, { root: true });

    return GarSubscriptionsRepository.createSubscription(params)
      .then(() => {
        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(
              `message.notifications.garSubscriptions.createSubscripionSuccess`,
            ),
          },
          { root: true },
        );
      })
      .catch((error) => {
        let message = state.$t(
          `message.notifications.garSubscriptions.createSubscripionError`,
        );

        try {
          if ("message" in error.response.data) {
            let data = error.response.data;

            let detailsMessage = data.details;
            if ("code" in data) {
              detailsMessage = `(${data.code}) ${detailsMessage}`;
            }

            message += ` ${state.$t(`message.detail`)} : ${detailsMessage}`;
          }
        } catch (err) {
          // no data in response, nothing to do
        }

        dispatch(
          "notifications/addError",
          {
            message: message,
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  updateSubscription({ dispatch, commit, state }, params = {}) {
    dispatch("loadings/enableLoadings", {}, { root: true });

    return GarSubscriptionsRepository.updateSubscription(params)
      .then(() => {
        if ("codeProjetRessource" in params) {
          commit("SAVE_LAST_CODE_PROJECT", params.codeProjetRessource);
        }
        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(
              `message.notifications.garSubscriptions.updateSubscripionSuccess`,
            ),
          },
          { root: true },
        );
      })
      .catch((error) => {
        let message = state.$t(
          `message.notifications.garSubscriptions.updateSubscripionError`,
        );

        try {
          console.log(error.response.data);
          if ("message" in error.response.data) {
            let data = error.response.data;

            let detailsMessage = data.details;
            if ("code" in data) {
              detailsMessage = `(${data.code}) ${detailsMessage}`;
            }

            message += ` ${state.$t(`message.detail`)} : ${detailsMessage}`;
          }
        } catch (err) {
          // no data in response, nothing to do
        }

        dispatch(
          "notifications/addError",
          {
            message: message,
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  getEstablishments({ commit, dispatch, state }, params = {}) {
    dispatch("loadings/enableLoadings", {}, { root: true });

    return GarSubscriptionsRepository.getEstablishments(params)
      .then((response) => {
        const establishments = response.data.results;
        commit("SAVE_ESTABLISHMENTS", establishments);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.garSubscriptions.getEstablishmentsError`,
            ),
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  deleteSubscription({ commit, dispatch, state }, id) {
    dispatch("loadings/enableLoadings", {}, { root: true });

    return GarSubscriptionsRepository.deleteSubscription(id)
      .then(() => {
        commit("RESET_ESTABLISHMENTS");

        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(
              `message.notifications.garSubscriptions.deleteSubscripionSuccess`,
            ),
          },
          { root: true },
        );
      })
      .catch((error) => {
        let message = state.$t(
          `message.notifications.garSubscriptions.deleteSubscripionError`,
        );

        try {
          console.log(error.response.data);
          if ("message" in error.response.data) {
            let data = error.response.data;

            let detailsMessage = data.details;
            if ("code" in data) {
              detailsMessage = `(${data.code}) ${detailsMessage}`;
            }

            message += ` ${state.$t(`message.detail`)} : ${detailsMessage}`;
          }
        } catch (err) {
          // no data in response, nothing to do
        }

        dispatch(
          "notifications/addError",
          {
            message: message,
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  saveSubscription({ commit }, subscription) {
    commit("SAVE_SUBSCRIPTION", subscription);
  },
  resetEstablishments({ commit }) {
    commit("RESET_ESTABLISHMENTS");
  },
};

const mutations = {
  SAVE_SUBSCRIPTIONS(state, subscriptions) {
    state.subscriptions = subscriptions;
  },
  SAVE_SUBSCRIPTION(state, subscription) {
    state.subscription = subscription;
  },
  SAVE_ESTABLISHMENTS(state, establishments) {
    state.establishments = establishments;
  },
  RESET_SUBSCRIPTIONS(state) {
    state.subscriptions = [];
  },
  RESET_ESTABLISHMENTS(state) {
    state.establishments = [];
  },
  SAVE_LAST_CODE_PROJECT(state, codeProject) {
    state.lastCodeProject = codeProject;
  },
  RESET_LAST_CODE_PROJECT(state) {
    state.lastCodeProject = "";
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
